import { c as _c } from "react/compiler-runtime";
import { useMutation } from '@tanstack/react-query';
import { OtpType, useTurnkey } from '@turnkey/react-wallet-kit';
import { useResolveCreatorLoginTarget } from '../../../../generated/mutations/useResolveCreatorLoginTarget.gen.js';
/** Used only by /creator/login; never auto-selects an organization or creates one. */
export function useCreatorLogin() {
  const $ = _c(8);
  const target = useResolveCreatorLoginTarget();
  const turnkey = useTurnkey();
  let t0;
  if ($[0] !== target || $[1] !== turnkey) {
    t0 = {
      retry: false,
      mutationFn: async email => {
        ;
        try {
          const contact = email.trim().toLowerCase();
          const {
            organizationId
          } = await target.mutateAsync({
            email: contact
          });
          const challenge = await turnkey.initOtp({
            contact,
            otpType: OtpType.Email
          });
          return {
            contact,
            organizationId,
            otpId: challenge.otpId,
            otpEncryptionTargetBundle: challenge.otpEncryptionTargetBundle
          };
        } catch (t1) {
          const error = t1;
          console.warn("[creator-login] start_failed");
          throw error;
        }
      }
    };
    $[0] = target;
    $[1] = turnkey;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const start = useMutation(t0);
  let t1;
  if ($[3] !== turnkey) {
    t1 = {
      retry: false,
      mutationFn: async t2 => {
        const {
          challenge: challenge_0,
          code
        } = t2;
        ;
        try {
          const {
            verificationToken
          } = await turnkey.verifyOtp({
            otpId: challenge_0.otpId,
            otpCode: code,
            otpEncryptionTargetBundle: challenge_0.otpEncryptionTargetBundle
          });
          await turnkey.loginWithOtp({
            verificationToken,
            organizationId: challenge_0.organizationId
          });
        } catch (t3) {
          const error_0 = t3;
          console.warn("[creator-login] verify_failed");
          throw error_0;
        }
      }
    };
    $[3] = turnkey;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const verify = useMutation(t1);
  let t2;
  if ($[5] !== start || $[6] !== verify) {
    t2 = {
      start,
      verify
    };
    $[5] = start;
    $[6] = verify;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}